// File: context/UserIdContext.jsx
import React, { createContext, useState, useContext, useEffect } from 'react';
import webNativeBridge from '../utils/WebNativeBridge';

// Create the context
const UserIdContext = createContext();

export const UserIdProvider = ({ children }) => {
  const [userId, setUserId] = useState(() => {
    // Try to get from localStorage first for persistence
    return localStorage.getItem('injectedUserId') || null;
  });

  // Initialize the bridge on component mount
  useEffect(() => {
    webNativeBridge.init();
    
    // Check if we already have an injected user ID
    const lastUserId = webNativeBridge.getLastInjectedUserId();

    console.log(lastUserId)
    if (lastUserId) {
      handleUserIdInjection(lastUserId);
    }
    
    // Listen for user ID from the native app
    const unsubscribe = webNativeBridge.on('USER_ID', handleUserIdInjection);
    
    return () => {
      unsubscribe();
    };
  }, []);
  
  // Handle when user ID is received from the native app
  const handleUserIdInjection = (injectedUserId) => {
    console.log('Setting injected user ID:', injectedUserId);
    
    if (injectedUserId) {
      setUserId(injectedUserId);
      localStorage.setItem('injectedUserId', injectedUserId);
    }
  };

  return (
    <UserIdContext.Provider value={{ userId }}>
      {children}
    </UserIdContext.Provider>
  );
};

// Custom hook to use the user ID context
export const useUserId = () => {
  const context = useContext(UserIdContext);
  if (context === undefined) {
    throw new Error('useUserId must be used within a UserIdProvider');
  }
  return context.userId;
};